import CryptoJS from "crypto-js";
import StorageConfig from "@/services/config/StorageConfig";

export function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

export function currencyFormatNumberComma(v) {
  if (v === null) {
    return 0;
  }
  if (v !== "" && v !== undefined) {
    var num = v.toString().split("").reverse().join("");
    const x = num.match(/\d{1,3}/g);
    const ribuan = x.join(",").split("").reverse().join("");
    return ribuan;
  } else if (v === 0) {
    return v;
  } else if (v === null) {
    return 0;
  }
}

export function formatRupiah(angka, prefix) {
  var number_string = angka.replace(/[^,\d]/g, "").toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
  return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
}

function checkFirstDigitIsZero(input) {
  if (typeof input !== "string") {
    input = input.toString();
  }
  return input.charAt(0) === "0";
}

export function formattedNumber(number) {
  if (number != null) {
    const test = checkFirstDigitIsZero(number);
    if (test) {
      return number;
    } else {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  return "";
}

export function formattedNumberWithDash(number) {
  if (number != null) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return "-";
}

export function formattedNumberGene(number) {
  if (number != null) {
    const num = Number(number);
    if (isNaN(num)) return number;
    const formatted = num.toLocaleString("en-US", {
      minimumFractionDigits: 6,
      maximumFractionDigits: 7,
    });
    return formatted;
  }

  return "-";
}

export function decrypt(data) {
  if (!data) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  } catch (e) {
    console.error("Decryption failed:", e);
    return null;
  }
}

export function checkIsGuest() {
  try {
    const dataUser = StorageConfig.getData();
    if (dataUser) {
      const decryptedData = decrypt(dataUser);
      if (decryptedData) {
        const parsed = JSON.parse(decryptedData);
        return parsed && parsed.roleId && parsed.roleId.toUpperCase() === "GUEST";
      }
    }
  } catch (e) {
    //
  }
  return false;
}

export function getIconUrl(iconName) {
  if (!iconName) return "";
  try {
    const sprite = require("@/assets/svg/icon-sprite.svg");
    const path = sprite && sprite.default ? sprite.default : sprite;
    return `${path}#${iconName}`;
  } catch (e) {
    return "";
  }
}

export function formattedNumberId(number) {
  if (number != null && number !== "" && number !== "-") {
    if (typeof number === "string") {
      const trimmed = number.trim();
      if (trimmed === "" || trimmed === "-") return "-";
      if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(trimmed)) {
        return trimmed;
      }
    }
    const num = Number(number);
    if (isNaN(num)) return "-";

    return num.toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 7,
    });
  }

  return "-";
}